import baseAPI from '@/http'

const router = 'api/municipio'

export const cityAPI = {
  create: (city) => baseAPI.post(router, city),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getMunicipioTema: (temaId, usuarioId) => baseAPI.get(`${router}/get-municipios-tema?temaId=${temaId}&usuarioId=${usuarioId}`),
  listNames: () => baseAPI.get(router + '/get-nomes'),
  getTasksReport: (id) => baseAPI.get(`${router}/relatorio-tarefa/${id}`),
  updateImageMunicipio: (val) => baseAPI.put(`${router}/update-imagem`, val),
  getRadar: (fill) => baseAPI.post(`${router}/get-radar`, fill),
  getMiniDash: (municipioId) => baseAPI.get(`${router}/get-mini-dash/${municipioId}`),
  getMunicipioGov: (municipioId) => baseAPI.get(`${router}/get-municipio-gov/${municipioId}`),

 
}
